import { Controller } from "@hotwired/stimulus"

// Ui::Form::PhosphorIconComponent: previews the typed Phosphor class ("ph-handshake"),
// or the default icon while the field is blank.
export default class extends Controller {
  static targets = ["input", "preview"]
  static values = { defaultIcon: String }

  update () {
    const icon = this.inputTarget.value.trim() || this.defaultIconValue
    this.previewTarget.className = `ph ${icon}`
  }
}
